var getNative = require('./_getNative');

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;



//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/_opy_VqP/0/cw/ws/uvocorp.com/gatsby/~/lodash/_defineProperty.js
// module id = 315
// module chunks = 35783957827783